import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { LOGO_MARK, formatApiErrorDetail } from "../lib/api";
import { Input } from "../components/ui/input";
import { Button } from "../components/ui/button";
import { Label } from "../components/ui/label";
import { Loader2, ArrowLeft } from "lucide-react";

export default function AdminLogin() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setLoading(true);
    try {
      await login(email, password);
      nav("/admin");
    } catch (e) {
      setErr(formatApiErrorDetail(e.response?.data?.detail));
    } finally { setLoading(false); }
  };

  return (
    <div className="grain relative min-h-screen flex items-center justify-center px-6">
      <form onSubmit={submit} className="max-w-sm w-full rounded-xl border border-white/10 bg-[#12141A] p-8" data-testid="admin-login-form">
        <img src={LOGO_MARK} alt="E.O.VO" className="h-14 w-14 object-contain mx-auto mb-4" />
        <h1 className="font-head text-2xl text-center font-bold">Admin Sign In</h1>
        <p className="text-center text-xs text-[#A1A1AA] mt-1 mb-6">E.O.VO content management</p>
        <div className="space-y-4">
          <div><Label className="text-xs text-[#A1A1AA]">Email</Label>
            <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="login-email" className="bg-[#0B0C10] border-white/10 mt-1" /></div>
          <div><Label className="text-xs text-[#A1A1AA]">Password</Label>
            <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="login-password" className="bg-[#0B0C10] border-white/10 mt-1" /></div>
          {err && <p className="text-sm text-[#E04F5F]" data-testid="login-error">{err}</p>}
          <Button type="submit" disabled={loading} data-testid="login-submit" className="w-full bg-[#C8A97E] text-[#0B0C10] hover:bg-[#B3956D] font-semibold rounded-sm">
            {loading ? <Loader2 className="animate-spin" size={18} /> : "Sign In"}
          </Button>
        </div>
        <Link to="/" className="flex items-center justify-center gap-2 mt-6 text-xs text-[#A1A1AA] hover:text-[#C8A97E]"><ArrowLeft size={13} /> Back to site</Link>
      </form>
    </div>
  );
}
